import type { ApolloClient, ApolloError } from '@apollo/client'
import gql from 'graphql-tag'
import {
  RetrieveDeviceRegistrationStatusInput,
  DeviceRegistrationStatus,
  identityDeviceNotFound,
} from '../../../../api'
import { getAppSyncError } from 'admin-web-utils'

export type DeviceNotFound = 'DeviceNotFound'

export const QUERY = gql`
  query RetrieveDeviceRegistrationStatus(
    $input: RetrieveDeviceRegistrationStatusInput!
  ) {
    retrieveDeviceRegistrationStatus(input: $input) {
      deviceId
      hasReachedRegistrationLimit
    }
  }
`

export async function retrieveDeviceRegistrationStatus(
  client: ApolloClient<unknown>,
  input: RetrieveDeviceRegistrationStatusInput,
): Promise<DeviceRegistrationStatus | DeviceNotFound> {
  try {
    const response = await client.query({
      query: QUERY,
      fetchPolicy: 'no-cache',
      variables: {
        input,
      },
    })
    return response.data.retrieveDeviceRegistrationStatus
  } catch (error) {
    if (
      getAppSyncError(error as ApolloError, 'retrieveDeviceRegistrationStatus')
        ?.errorType === identityDeviceNotFound
    ) {
      return 'DeviceNotFound'
    }

    throw error
  }
}
